import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ../~/react-transition-group/esm/TransitionGroupContext.js
// module id = 721
// module chunks = 121